import { Expose } from 'class-transformer'

import { Base } from './Base'

export class CustomField extends Base {
  @Expose({ name: 'xid' })
  guid: string = ''

  name: string = ''
  label: string = ''
}
